import React from 'react'
import { Modal } from 'react-bootstrap'
import useGetAppValue from '../hooks/useGetAppValue'
import useWindowEventListenersEffect from '../hooks/useWindowEventListenersEffect'
import useCountryEffect from '../hooks/useCountryEffect'
import useCartIdEffect from '../hooks/useCartIdEffect'
import AppContext from '../context/app'
import Violator from '../components/violator'
import Navbar from '../components/navbar'
import InMusic from '../components/inmusic'
import Footer from '../components/footer'
import { ThemeProvider } from '@emotion/react'
import * as styles from '../styles/exports.module.scss'

export default function MainLayout({ children }) {
    const value = useGetAppValue()
    const { globalModalChildren, setGlobalModalChildren } = value
    
    useWindowEventListenersEffect(value)
    useCountryEffect(value)
    useCartIdEffect(value)

    const theme = {
        colors: {
            primary: styles.primaryColor,
            secondary: styles.secondaryColor,
            light: styles.lightColor,
            dark: styles.darkColor,
        },
        fonts: {
            inter: styles.interFont,
            poppins: styles.poppinsFont,
            oswald: styles.oswaldFont,
            changelingNeo: styles.changelingNeoFont,
            shuttleblockCondensed: styles.shuttleblockCondensedFont,
            microgrammaExtdDBold: styles.microgrammaExtdDBoldFont,
            zenTokyoZoo: styles.zenTokyoZooFont,
            pathwayGothicOne: styles.pathwayGothicOneFont,
            spaceGroteskVariable: styles.spaceGroteskVariableFont,
        }
    }

    return (
        <AppContext.Provider value={value}>
            <ThemeProvider theme={theme}>
                <Violator style={{ zIndex: value.isModalOpen ? 2 : 4 }} />
                <Navbar style={{ zIndex: value.isModalOpen ? 2 : 3 }} />
                
                <main
                    className='position-relative'
                    style={{ zIndex: value.isModalOpen ? 3 : 2 }}
                >
                    {children}
                </main>
                
                <footer
                    className='position-relative'
                    style={{ zIndex: 1 }}
                >
                    <InMusic />
                    <Footer />
                </footer>
    
                <Modal
                    size='xl'
                    centered
                    show={Boolean(globalModalChildren)}
                    onHide={() => setGlobalModalChildren(undefined)}
                    css={{ '& .modal-content': { background: 0 }}}
                >
                    {globalModalChildren}
                </Modal>
            </ThemeProvider>
        </AppContext.Provider>
    )
}